import React, { useState } from "react";
import "./FAQ.css";
import { ChevronDown } from "lucide-react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Como funciona o processo de consultoria da Arcadian?",
      answer:
        "Nosso processo começa com um diagnóstico completo da sua clínica, seguido pelo desenvolvimento de uma estratégia personalizada. Implementamos as soluções com acompanhamento contínuo e ajustes baseados em resultados mensuráveis. Todo o processo é colaborativo e transparente.",
    },
    {
      question: "Qual é o prazo médio para ver resultados?",
      answer:
        "Os primeiros resultados aparecem entre 30-60 dias, com melhorias significativas em 3-6 meses. O tempo varia conforme o tipo de clínica, mercado local e nível de implementação das estratégias. Nosso foco é em resultados sustentáveis e duradouros.",
    },
    {
      question: "A Arcadian trabalha com que tipos de clínicas?",
      answer:
        "Atendemos clínicas e consultórios de diversas especialidades: dermatologia, oftalmologia, odontologia, cardiologia, ortopedia, ginecologia, entre outras. Nosso foco são estabelecimentos que buscam crescimento premium e excelência operacional.",
    },
    {
      question: "Qual é o investimento necessário para a consultoria?",
      answer:
        "O investimento varia conforme o escopo do projeto e necessidades específicas da sua clínica. Oferecemos diferentes modalidades de consultoria, desde projetos pontuais até acompanhamentos mensais. Entre em contato para uma proposta personalizada.",
    },
    {
      question: "Vocês trabalham com clínicas de outras cidades?",
      answer:
        "Sim! Atendemos clínicas em todo o Brasil. Temos metodologia híbrida que combina atendimento presencial e remoto, garantindo a mesma qualidade independente da localização. Nossa equipe está preparada para projetos nacionais.",
    },
    {
      question: "Como é feito o acompanhamento dos resultados?",
      answer:
        "Utilizamos dashboards personalizados com KPIs específicos da sua clínica. Realizamos reuniões regulares de acompanhamento, relatórios mensais detalhados e ajustes estratégicos baseados nos dados coletados. Transparência total nos resultados.",
    },
    {
      question: "A Arcadian oferece garantia de resultados?",
      answer:
        "Trabalhamos com metas claras e mensuráveis definidas em conjunto. Nossa metodologia é comprovada e nosso histórico de 98% de satisfação demonstra nossa eficácia. Discutimos garantias específicas durante a proposta personalizada.",
    },
    {
      question: "É possível fazer apenas um projeto específico?",
      answer:
        "Absolutamente! Oferecemos desde projetos pontuais (reposicionamento, implementação de CRM, treinamento de equipe) até consultorias completas de longo prazo. Adaptamos nossos serviços às suas necessidades específicas.",
    },
  ];

  return (
    <section id="faq" className="faq-section" data-aos="fade-in">
      <div className="faq-container">
        <div className="faq-header">
          <span className="faq-label">Perguntas Frequentes</span>
          <h2 className="faq-title">
            Tire suas <span className="highlight">dúvidas</span>
          </h2>
          <p className="faq-subtitle">
            As perguntas mais comuns sobre nossa consultoria especializada em
            clínicas e consultórios.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "active" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3>{faq.question}</h3>
                <ChevronDown
                  className={`faq-icon ${openIndex === index ? "rotate" : ""}`}
                />
              </button>
              {openIndex === index && (
                <div
                  className={`faq-answer ${openIndex === index ? "open" : ""}`}
                  style={{ maxHeight: openIndex === index ? "500px" : "0px" }}
                >
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <br />
        <br />
        <br />
        <br />
        <div className="faq-header">
          <span className="faq-label">
            Pronto para direcionar sua mensagem como Hermes?
          </span>
          <h2 className="faq-title">
            Pare de apostar no <span className="highlight">próximo lead</span>
          </h2>
          <p className="faq-subtitle">
            Clique no botão abaixo e agende seu diagnóstico gratuito com nosso
            time. Vamos analisar sua operação e te mostrar exatamente onde sua
            mensagem está se perdendo.
          </p>
        </div>

        <div className="faq-bottom-cta">
          <button className="btn-primary">Agendar Diagnóstico</button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
